import * as React from 'react'; // eslint-disable-line
import styled from 'styled-components';

import { InjectedColorProps } from 'react-color';

const StyledCustomColorPickerPointer = styled.div`
    position: absolute;
    cursor: pointer;
    height: 3px;
    width: 19px;
    top: -3px;
    left: -1px;
    right: -1px;
    border: 1px solid #000;
    background: #fff;
    opacity: 0.8;
`;

const CustomColorPickerPointer = () => {
    return <StyledCustomColorPickerPointer />;
};

const StyledCustomColorPickerPointerCircle = styled.div<InjectedColorProps>`
    width: 12px;
    height: 12px;
    border-radius: 6px;
    box-shadow: ${({ hsl }) => {
        const isLight = (hsl?.l || 1) > 0.5;
        return isLight ? 'inset 0 0 0 1px #000' : 'inset 0 0 0 1px #fff';
    }};
    transform: translate(-6px, -6px);
`;

const CustomColorPickerPointerCircle = ({ hsl }: InjectedColorProps) => (
    <StyledCustomColorPickerPointerCircle hsl={hsl} />
);

export { CustomColorPickerPointer, CustomColorPickerPointerCircle };
